/*
 * 3P · F1C5 · Suggerimenti nel carrello laterale.
 * - Se manca qualcosa per la spedizione gratis: 3 prodotti disponibili dello stesso tipo (product type) dell'ultimo
 *   prodotto aggiunto, i più economici tra quelli che da soli fanno superare la soglia. Li prende da
 *   /collections/types?q=<tipo> con la sezione sections/p3-cart-upsell.liquid.
 * - Se la spedizione è già gratis, o non si trova nulla: i suggerimenti di sempre di Shopify ("Di solito acquistano anche").
 * La soglia e il totale arrivano dall'avviso spedizione del carrello (shipping-notice), quindi un prodotto col tag
 * "spedizione gratuita" nel carrello vale già come spedizione gratis.
 */
class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const form = document.getElementById('AjaxCartForm');
		if ( ! form ) return;
		const cartItems = form.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length == 0 ) return;
		this.p3TypeUpsell(form)
			.then(done => { if ( ! done ) this.p3Standard(cartItems); })
			.catch(e => { console.log(e); this.p3Standard(cartItems); });
	}

	p3Standard(cartItems){
		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]');
				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.innerHTML;
				}
			});
	}

	async p3Fetch(type, params){
		const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
		const query = new URLSearchParams(Object.assign({ q: type, sort_by: 'price-ascending', section_id: 'p3-cart-upsell' }, params));
		const text = await fetch(`${root}collections/types?${query.toString()}`).then(r => r.text());
		return new DOMParser().parseFromString(text, 'text/html').querySelector('[data-js-cart-recommendations-performed]');
	}

	async p3TypeUpsell(form){
		const notice = form.querySelector('shipping-notice');
		if ( ! notice ) return false;
		const gap = Number(notice.dataset.freeShipping) - Number(notice.dataset.cartTotal);
		if ( ! (gap > 0) ) return false;

		const cart = await fetch(`${KROWN.settings.routes.cart_url}.js`).then(r => r.json());
		const last = cart.items && cart.items[0];
		if ( ! last || ! last.product_type ) return false;
		const inCart = new Set(cart.items.map(i => String(i.product_id)));

		const minEuro = Math.ceil(gap) / 100;
		const pickFrom = wrap => wrap ? [...wrap.querySelectorAll('[data-js-product-item]')]
			.filter(i => ! inCart.has(i.dataset.productId) && Number(i.dataset.price) >= gap)
			.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price)) : [];

		// prima i prodotti poco sopra la cifra che manca, poi tutti quelli sopra
		let wrap = await this.p3Fetch(last.product_type, { 'filter.v.price.gte': minEuro, 'filter.v.price.lte': minEuro + 30 });
		let pick = pickFrom(wrap);
		if ( pick.length < 3 ) {
			const wrap2 = await this.p3Fetch(last.product_type, { 'filter.v.price.gte': minEuro });
			const seen = new Set(pick.map(i => i.dataset.productId));
			pick = pick.concat(pickFrom(wrap2).filter(i => ! seen.has(i.dataset.productId)));
			wrap = wrap || wrap2;
		}
		pick = pick.slice(0, 3);
		if ( ! wrap || pick.length == 0 ) return false;

		const grid = wrap.querySelector('.grid');
		grid.innerHTML = '';
		pick.forEach(i => grid.appendChild(i));
		const heading = wrap.querySelector('[data-js-p3-heading]');
		if ( heading ) heading.textContent = 'Aggiungi uno di questi: la spedizione diventa gratis';
		this.innerHTML = wrap.innerHTML;
		this.p3BindAdd();
		return true;
	}

	// pulsante "Aggiungi" sui prodotti suggeriti (solo prodotti con una variante; gli altri hanno "Scegli formato")
	p3BindAdd(){
		const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
		this.querySelectorAll('[data-p3-add]').forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				btn.disabled = true;
				btn.textContent = 'Aggiungo…';
				fetch(`${root}cart/add.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body: JSON.stringify({ items: [{ id: Number(btn.dataset.p3Add), quantity: 1 }] })
				})
					.then(r => { if ( ! r.ok ) throw new Error('add'); return r.json(); })
					.then(() => {
						btn.textContent = 'Aggiunto';
						if ( window.refreshCart ) window.refreshCart();
					})
					.catch(() => {
						btn.textContent = 'Non disponibile';
					});
			});
		});
	}
}
customElements.define('cart-recommendations', CartRecommendations);
